const angular = require('angular');
var pdfjsImport = require('../imports/pdfjs');

var app = angular.module('learn-controllers');

/**
 * Edit Presentations Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 * @argument {Files} Presentations injected to gain access to the Files resource
 */
app.controller('editPresentation', ['Application', 'Authorization', 'Analyze', 'Presentations', 'Viewables', 'AccessHelper', '$scope', '$translate', '$filter', function(Application, Authorization, Analyze, Presentations, Viewables, AccessHelper, $scope, $translate, $filter) {
  var self = this;
  var routeParameters = Application.navigation.getRouteParameters();
  var newPresentation = routeParameters.id === 'new' || !routeParameters.id;
  self.features = Application.features.flags();

  self.allowance = {
    create_presentation: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'presentations_create']], ['admin', 'creator', 'collaborator']),
    edit_presentation: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'presentations_edit'], ['admin', 'content', 'my_content_edit']], ['admin', 'creator', 'collaborator']),
  };

  if (!self.features.presentations || (!newPresentation && !self.allowance.edit_presentation) || (newPresentation && !self.allowance.create_presentation)) {
    Application.navigation.goTo('/explore');
    return;
  }

  self.authtoken = Authorization.getAuthToken();
  self.user = self.authtoken.user;
  self.pickerActive = false;
  self.archiveInfo = {};

  var locationChange = $scope.$on('$locationChangeStart', function(event) {
    if (self.options.editSaved) {
      // Allow the route change to progress
      locationChange();
      return;
    }

    // Halt the route change and question the action
    self.navigationPath = {};
    self.navigationPath.targetPath = Application.navigation.getPath();
    self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
    self.navigationPath.targetHash = Application.navigation.getHash();

    event.preventDefault();
    self.options.showDeparture = true;
    self.onLocationChange = function() {
      if (self.options.privateId) {
        self.communications.removePresentation(self.options.privateId, true);
      }
      locationChange();
    };

    self.onLocationChangeSave = function() {
      if (self.options.privateId) {
        self.communications.saveDraft();
        locationChange();
      }
    };
  });

  self.goBack = function() {
    if (!self.options.denied || !self.options.backLocation) {
      Application.navigation.back();
      self.options.denied = true;
      return;
    }
    self.options.denied = true;
    var location = self.options.backLocation.split('/#/');
    if (location.length !== 2) {
      Application.navigation.back();
      return;
    }
    Application.navigation.goTo(location[1]);
  };

  self.presentation = {
    user: self.user._id,
    slides: [],
    tags: [],
    draft: true,
    linked_category: [],
    privacy_collaborators: [],
    explore_hide: false,
    background_theme: 'dark',
    allow_comments: false
  };
  self.showCollaborators = false;

  var routeParameters = Application.navigation.getRouteParameters();
  self.options = {
    newPresentation: routeParameters.id === 'new' || !routeParameters.id,
    leaveSave: false,
    editSaved: true,
    backLocation: Application.navigation.history[Application.navigation.history.length - 2],
    denied: false,
    showDeparture: false,
    activeTab: 'details',
    contentOption: 'unchanged',
    showDelete: false,
    instructions: null,
    addType: null,
    mediumOpts: {
      'targetBlank': true,
      'toolbar': {
        'buttons': ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3', 'quote', 'unorderedlist', 'orderedlist']
      }
    },
    privateId: null
  };

  self.navigation = {
    directory: {
      'details': {
        next: 'content',
        previous: null,
        required: ['title', 'author', 'description']
      },
      'content': {
        next: 'images',
        previous: 'details',
        required: ['slides']
      },
      'images': {
        next: 'categories',
        previous: 'content',
        required: null
      },
      'categories': {
        next: 'settings',
        previous: 'images',
        required: null
      },
      'settings': {
        next: '',
        previous: 'categories',
        required: null
      }
    },
    nextSection: function(item) {
      var nextClicked = item ? false : true;
      var item = item ? this.directory[item].previous : self.options.activeTab;
      var next = this.directory[item].next;
      var missing = '';
      var required_fields = true;

      var findIssues = function(check) {
        var current = self.navigation.directory[check];
        if (current.required) {
          for (var i = 0; i < current.required.length; i++) {
            if (!self.presentation[current.required[i]]) {
              required_fields = false;
              missing = missing + ' ' + current.required[i] + ',';
            }
          }
        }
        if (current.previous) {
          findIssues(current.previous);
        }
      };

      findIssues(item);

      if (required_fields && next) {

        if (self.options.newPresentation && !self.options.privateId) {
          self.communications.createInitial()
          .then(function(presentation) {
            self.options.activeTab = next;
            Application.scrollTop();
          });
          return;
        }

        if (!nextClicked) {
          self.options.activeTab = next;
          Application.scrollTop();
          return;
        }

        if (!self.options.editSaved) {
          self.communications.saveProgress('next')
          .then(function() {
            self.options.activeTab = next;
            Application.scrollTop();
          });
        } else {
          self.options.activeTab = next;
          Application.scrollTop();
        }
      }

      // Need to display messages on error
      if (missing) {
        Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_fieldsMissing'] + missing.slice(0, -1) + '.', duration: 5});
      }
    }
  };

  self.communications = {
    removing: false,
    saving: false,
    save: function(body, partialSave) {
      self.communications.saving = true;
      if(self.user.is_collaborator) {
        body.approval_required = true;
        body.approved = false;
      }
      return Presentations.update({
        subresource: self.presentation._id,
        fields: 'company,user,title,author,description,slides,banner_image,image,cover_justification,featured_justification,published,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,linked_category,explore_hide,tags,end_copy,background_theme,private'
      }, body).$promise.then(function(presentation) {
        Analyze.record({resource: 'modifications'}, {document: presentation._id, type: 'presentation'});
        Application.analyticsProvider.trackEvent('presentation_updated', {content: presentation._id, content_type: 'presentation', title: presentation.title});
        self.communications.saving = false;
        if (!self.options.newPresentation && !partialSave) {
          self.options.editSaved = true;
        }
      })
      // .catch(function(error) {
      //   console.log('error: ', error)
      //   self.communications.saving = false;
      //   if (error.data && error.data.status === 401 && error.data.message) {
      //     Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
      //     return;
      //   }
      //   Application.messaging.addMessage({type: 'error', text: 'There was an error while attempting to save this presentation.', duration: 5})
      // });
    },
    saveProgress: function(next) {
      var updatePresentation = JSON.parse(JSON.stringify(self.presentation));
      delete updatePresentation.slides;

      return self.communications.save(updatePresentation)
      .then(function() {
        Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.presentation_savedPt1'] + ' ' + $filter('limitTo')(self.presentation.title, 25) + (self.presentation.title.length > 25 ? '[...]' : '') + ' ' + self.translations['modules.notifications.presentation_savedPt2'], duration: 5});
      }).catch(function(error) {
        console.log('error 1: ', error)
        self.communications.saving = false;
        if (error.data && error.data.status === 401 && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
          return;
        }
        Application.messaging.addMessage({type: 'error', text: 'There was an error while attempting to save this presentation.', duration: 5})
      });;
    },
    saveDraft: function() {
      var updatePresentation = JSON.parse(JSON.stringify(self.presentation));
      delete updatePresentation.slides;

      self.communications.save(updatePresentation)
      .then(function() {
        self.options.privateId = null;
        self.options.newPresentation = false;
        self.options.leaveSave = false;
        self.options.editSaved = true;
        Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.presentation_savedPt1'] + ' ' + $filter('limitTo')(self.presentation.title, 25) + (self.presentation.title.length > 25 ? '[...]' : '') + ' ' + self.translations['modules.notifications.presentation_savedPt2'], duration: 5});
      }).catch(function(error) {
        console.log('error 2: ', error)
        self.communications.saving = false;
        if (error.data && error.data.status === 401 && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
          return;
        }
        Application.messaging.addMessage({type: 'error', text: 'There was an error while attempting to save this presentation.', duration: 5})
      });;
    },
    publish: function() {
      if (!self.presentation.slides || !self.presentation.slides.length) {
        Application.messaging.addMessage({type: 'information', text: 'Please add some slides before publishing.', duration: 5});
        return;
      }

      for (var i = 0; i < self.presentation.slides.length; i++) {
        if (self.presentation.slides[i].type === 'video' && self.presentation.slides[i].properties && self.presentation.slides[i].properties.length) {
          for (var j = 0; j < self.presentation.slides[i].properties.length; j++) {
            if (self.presentation.slides[i].properties[j].name === 'transcoding' && self.presentation.slides[i].properties[j].value && self.presentation.slides[i].properties[j].value !== 'false') {
              Application.messaging.addMessage({type: 'information', text: 'Publishing will not be allowed until all videos have finished transcoding. You will recieve and email upon transcoding completion and may try again then.', duration: 9});
              return;
            }
          }
        }
      }

      var updatePresentation = JSON.parse(JSON.stringify(self.presentation));
      delete updatePresentation.slides;
      updatePresentation.published = true;

      self.communications.save(updatePresentation)
      .then(function() {
        if (!updatePresentation || !updatePresentation.published) {
          return;
        }
        self.presentation.published = true;
        setTimeout(function() {
          self.options.editSaved = true;
          Application.navigation.goTo('/view/presentations/' + self.presentation._id);
          $scope.$apply();
        }, 10);
        Application.messaging.addMessage({type: 'success', text: 'The presentation has been published to Explore.', duration: 5});
      }).catch(function(error) {
        console.log('error 3: ', error)
        self.communications.saving = false;
        if (error.data && error.data.status === 401 && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
          return;
        }
        Application.messaging.addMessage({type: 'error', text: 'There was an error while attempting to save this presentation.', duration: 5})
      });
    },
    addSlide: function(slide) {
      self.communications.saving = true;
      var body = {slide: slide};

      return Presentations.addSlide({
        subresource: self.presentation._id,
        fields: 'company,user,title,author,description,slides,banner_image,image,cover_justification,featured_justification,published,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,linked_category,explore_hide,tags,end_copy,background_theme,private'
      }, body).$promise.then(function(presentation) {
        self.presentation.slides = presentation.slides;
        self.communications.saving = false;
      }).catch(function(error) {
        Application.messaging.addMessage({type: 'error', text: 'There was an error while attempting to add a slide to this presentation.', duration: 5})
        self.communications.saving = false;
      });

    },
    getPresentation: function() {
      self.communications.saving = true;
      return Presentations.get({
        subresource: routeParameters.id,
        fields: 'company,user,title,author,description,slides,banner_image,image,cover_justification,featured_justification,published,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,linked_category,explore_hide,tags,end_copy,background_theme,private'
      }).$promise;
    },
    removePresentation: function(id, isPrivate) {
      self.communications.removing = true;
      self.communications.saving = true;
      Viewables.archive({
        content: [{id: id || routeParameters.id, type: 'presentation'}]
      }).$promise.then(function(results) {
        self.archiveInfo.results = results;
        self.archiveInfo.show = results.in_track?.length || results.in_workflow?.length || results.in_journey?.length;
        self.updateIndicator = false;
        self.showDelete = false;
        self.options.showDelete = false;
        self.communications.removing = false;
        self.communications.saving = false;
        if (self.archiveInfo.show) {
          return;
        }
        if (isPrivate) {
          return;
        }
        Application.messaging.addMessage({type: 'success', text: 'The presentation was deleted.', duration: 5});
        Application.navigation.goTo('/overview/content');
      }).catch(function(error) {
        self.options.showDelete = false;
        self.communications.removing = false;
        self.communications.saving = false;
        Application.messaging.addMessage({type: 'error', text: 'There was an error in attempting to delete this presentation. Please try again later.', duration: 5});
      });
    },
    createInitial: function() {
      if (!self.presentation._id) {
        self.communications.saving = true;
        if(self.user.is_collaborator) {
          self.presentation.approval_required = true;
          self.presentation.approved = false;
        }
        return Presentations.create({
          fields: 'company,user,title,author,description,slides,banner_image,image,cover_justification,featured_justification,published,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,linked_category,explore_hide,tags,end_copy,background_theme,private'
        }, self.presentation).$promise.then(function(presentation) {
          self.options.privateId = presentation._id;
          self.options.leaveSave = true;
          self.presentation._id = presentation._id;
          Analyze.record({resource: 'creations'}, {document: presentation._id, type: 'presentation'});
          Application.analyticsProvider.trackEvent('presentation_created', {content: presentation._id, content_type: 'presentation', title: presentation.title});
          self.communications.saving = false;
        }).catch(function(error) {
          self.communications.saving = false;
          if (error.data && error.data.status === 401 && error.data.message) {
            Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
          }
          console.log('Error in creation: ', error);
        });
      }
    },
    viewPresentation: function() {
      if (self.options.editSaved) {
        Application.navigation.goTo('/view/presentations/' + self.presentation._id);
        return;
      }

      var updatePresentation = JSON.parse(JSON.stringify(self.presentation));
      delete updatePresentation.slides;

      self.communications.save(updatePresentation)
      .then(function() {
        setTimeout(function() {
          self.options.editSaved = true;
          Application.navigation.goTo('/view/presentations/' + self.presentation._id);
          $scope.$apply();
        }, 10);
        Application.messaging.addMessage({type: 'success', text: 'The presentation has been saved.', duration: 5});
      }).catch(function(error) {
        console.log('error 4: ', error)
        self.communications.saving = false;
        if (error.data && error.data.status === 401 && error.data.message) {
          Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
          return;
        }
        Application.messaging.addMessage({type: 'error', text: 'There was an error while attempting to save this presentation.', duration: 5})
      });;
    }
  };

  self.addContent = {
    originalSlideTitle: null,
    currentlyEditing: null,
    saving: false,
    editSlide: null,
    addExisting: async function(item) {
      if (item.type === 'file') {
        await self.addContent.addFile(item);
        return;
      }
      if (item.type === 'video') {
        self.addContent.addVideo(item);
        return;
      }
    },
    cancelExisting: function() {
      if (self.options.addType === 'existing') {
        self.options.addType = null;
      }
    },
    cancelFile: function() {
      self.options.addType = null;
    },
    addFile: async function(file) {
      self.addContent.saving = true;
      var attempts = 0;
      var addFileSlide = async function() {
        var newSlide = {
          title: file.fileName || 'Add Title',
          type: 'file',
          content: file.link
        };
        const PDFJS = await pdfjsImport.importModule();
        PDFJS.disableWorker = true;
        PDFJS.getDocument(file.link).promise.then(function (pdfDoc) {
          newSlide.properties = [
            {
              name: 'totalPages',
              value: pdfDoc.numPages
            }
          ];

          self.communications.addSlide(newSlide)
          .then(function() {
            self.options.addType = null;
            self.addContent.saving = false;
            Application.messaging.addMessage({type: 'success', text: 'The file was added to this presentation.', duration: 5});
          });
        }).catch(function(error) {
          if (attempts < 4) {
            attempts++;
            addFileSlide();
            return;
          }
        });
      };

      await addFileSlide();
    },
    cancelVideo: function() {
      self.options.addType = null;
    },
    addVideo: function(video) {
      self.addContent.saving = true;
      var newSlide = {
        title: video.title || video.fileName || 'Add Title',
        type: video.source || 'video',
        content: video.link,
      };
      if (video.source_id) {
        newSlide.properties = [{name: 'source_id', value: video.source_id}];
      }
      if (video.transcoding) {
        newSlide.properties = [{
          name: 'transcoding_job',
          value: video.job.id
        }, {
          name: 'transcoding',
          value: true
        }, {
          name: 'transcoding_status',
          value: 'initial'
        }];
      }

      self.communications.addSlide(newSlide)
      .then(function() {
        if (video.transcoding) {
          Application.messaging.addMessage({type: 'success', text: 'The video was saved to this presentation. You will be notified upon transcoding completion.', duration: 5});
          return;
        }
        self.options.addType = null;
        self.addContent.saving = false;
        Application.messaging.addMessage({type: 'success', text: 'The video was saved to this presentation.', duration: 5});
      });
    },
    cancelImage: function() {
      self.options.addType = null;
      self.addContent.editSlide = null;
    },
    addImage: function(image) {
      self.addContent.saving = true;
      if (self.addContent.editSlide) {
        self.addContent.editSlide.content = image.link;
        self.addContent.saveContentEdit(self.addContent.editSlide)
        .then(function() {
          self.options.addType = null;
          self.addContent.saving = false;
          self.addContent.editSlide = null;
        });
        return;
      }

      var newSlide = {
        title: image.fileName || 'Add Title',
        type: 'image',
        content: image.link
      };
      self.communications.addSlide(newSlide)
      .then(function() {
        self.options.addType = null;
        self.addContent.saving = false;
        self.addContent.editSlide = null;
        Application.messaging.addMessage({type: 'success', text: 'The image was saved to this presentation.', duration: 5});
      });
    },
    editImage: function(slide) {
      this.editSlide = slide;
      self.options.addType = 'image';
    },
    startEdit: function(slide) {
      if (self.addContent.saving || self.communications.saving) {
        Application.messaging.addMessage({type: 'information', text: 'Please wait until the save in progress is complete.', duration: 5});
        return;
      }
      if (this.currentlyEditing) {
        Application.messaging.addMessage({type: 'error', text: 'Please finish the slide currently being edited.', duration: 5});
        return;
      }
      this.originalSlideTitle = slide.title.slice(0);
      this.currentlyEditing = slide._id;
    },
    inEdit: function(slide) {
      if (slide._id && slide._id.toString() && this.currentlyEditing && this.currentlyEditing.toString() && slide._id.toString() === this.currentlyEditing.toString()) {
        return true;
      }
      return false
    },
    cancelEdit: function(slide) {
      slide.title = this.originalSlideTitle;
      this.currentlyEditing = null;
    },
    saveTitleEdit: function(slide) {
      self.addContent.saving = true;
      self.communications.saving = true;
      var body = {slide: slide};
      return Presentations.editSlideTitle({
        subresource: self.presentation._id,
        fields: 'company,user,title,author,description,slides,banner_image,image,cover_justification,featured_justification,published,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,linked_category,explore_hide,tags,end_copy,background_theme,private'
      }, body).$promise.then(function(presentation) {
        self.presentation.slides = presentation.slides;
        self.addContent.currentlyEditing = null;
        self.addContent.originalSlideTitle = null;
        self.addContent.saving = false;
        self.communications.saving = false;
        Application.messaging.addMessage({type: 'success', text: 'Title edit saved.', duration: 5});
      }).catch(function(error) {
        self.addContent.saving = false;
        self.communications.saving = false;
        Application.messaging.addMessage({type: 'error', text: 'There was an error in saving the title. Please try again.', duration: 5});
      });
    },
    saveContentEdit: function(slide) {
      self.addContent.saving = true;
      self.communications.saving = true;
      var body = {slide: slide};
      return Presentations.editSlideContent({
        subresource: self.presentation._id,
        fields: 'company,user,title,author,description,slides,banner_image,image,cover_justification,featured_justification,published,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,linked_category,explore_hide,tags,end_copy,background_theme,private'
      }, body).$promise.then(function(presentation) {
        self.presentation.slides = presentation.slides;
        self.addContent.currentlyEditing = null;
        self.addContent.originalSlideTitle = null;
        self.addContent.saving = false;
        self.communications.saving = false;
        Application.messaging.addMessage({type: 'success', text: 'The slide has been saved.', duration: 5});
      }).catch(function(error) {
        self.addContent.saving = false;
        self.communications.saving = false;
        Application.messaging.addMessage({type: 'error', text: 'There was an error in saving the title. Please try again.', duration: 5});
      });
    },
    deleteSlide: function(slide) {
      if (self.addContent.saving || self.communications.saving) {
        Application.messaging.addMessage({type: 'information', text: 'Please wait until the save in progress is complete.', duration: 5});
        return;
      }
      self.communications.saving = true;
      self.addContent.saving = true;

      return Presentations.removeSlide({
        subresource: self.presentation._id,
        slideresource: slide._id,
        fields: 'company,user,title,author,description,slides,banner_image,image,cover_justification,featured_justification,published,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,linked_category,explore_hide,tags,end_copy,background_theme,private'
      }).$promise.then(function(presentation) {
        self.presentation.slides = presentation.slides
        Analyze.record({resource: 'modifications'}, {document: presentation._id, type: 'presentation'});
        Application.analyticsProvider.trackEvent('presentation_updated', {content: presentation._id, content_type: 'presentation', title: presentation.title});
        Application.messaging.addMessage({type: 'success', text: 'The slide was removed and the presentation has been saved.', duration: 5});
        self.communications.saving = false;
        self.addContent.saving = false;
      }).catch(function(err) {
        self.communications.saving = false;
        self.addContent.saving = false;
        Application.messaging.addMessage({type: 'error', text: 'There was an error in deleting that slide. Please try again.', duration: 5});
      });
    },
    positionTimeout: null,
    changePosition: function(slide, direction) {
      if (!slide || !slide.ordinal && slide.ordinal !== 0) {
        return;
      }
      if (slide.ordinal === 0 && direction === -1 || slide.ordinal === (self.presentation.slides.length - 1) && direction === 1) {
        return;
      }
      if (self.addContent.saving || self.communications.saving) {
        Application.messaging.addMessage({type: 'information', text: 'Please wait until the save in progress is complete.', duration: 5});
        return;
      }

      var found;
      for (var i = 0; i < self.presentation.slides.length; i++) {
        if (self.presentation.slides[i].ordinal === (slide.ordinal + direction)) {
          self.presentation.slides[i].ordinal = slide.ordinal;
          slide.ordinal = slide.ordinal + direction;
          found = true;
          break;
        }
      }
      if (!found) {
        return;
      }

      // wait 1.5 seconds after last click before saving
      if (self.addContent.positionTimeout) {
        window.clearTimeout(self.addContent.positionTimeout);
      }

      self.addContent.positionTimeout = setTimeout(function() {
        self.communications.saving = true;
        self.addContent.saving = true;
        var body = {slides: self.presentation.slides};

        return Presentations.editSlideOrder({
          subresource: self.presentation._id,
          fields: 'company,user,title,author,description,slides,banner_image,image,cover_justification,featured_justification,published,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,linked_category,explore_hide,tags,end_copy,background_theme,private'
        }, body).$promise.then(function(presentation) {
          self.presentation.slides = presentation.slides
          Analyze.record({resource: 'modifications'}, {document: presentation._id, type: 'presentation'});
          Application.analyticsProvider.trackEvent('presentation_updated', {content: presentation._id, content_type: 'presentation', title: presentation.title});
          Application.messaging.addMessage({type: 'success', text: 'The presentation order has been saved.', duration: 5});
          self.communications.saving = false;
          self.addContent.saving = false;
        }).catch(function(err) {
          self.communications.saving = false;
          self.addContent.saving = false;
          Application.messaging.addMessage({type: 'success', text: 'There was an error in saving the order of the presentation. Please try again.', duration: 5});
        });
      }, 1500);
    }
  };

  // ** REMINDER - I'm not sure this is a good idea. Would like to discuss
  // $scope.$on('$destroy', function() {
    // if (self.options.privateId) {
    //   self.communications.removePresentation(self.options.privateId);
    // }
  // });

  $scope.$watch('presentation.presentation', function(newVal, oldVal) {
    if (self.options.editSaved && newVal !== oldVal) {
      self.options.editSaved = false;
    }
  }, true);

  self.initialize = function() {
    if (self.user.role !== 'admin' && self.user.role !== 'creator' && !self.user.is_collaborator) {
      Application.navigation.goTo('/explore');
      return;
    }
    if (self.options.newPresentation) {
      if(self.user.is_collaborator) {
        self.presentation.privacy_collaborators.push(self.user._id);
      }
      return;
    }
    self.communications.getPresentation()
    .then(function(presentation) {
      if ((presentation.company !== self.authtoken.company._id)  || (self.user.is_collaborator && presentation.privacy_collaborators.length && presentation.privacy_collaborators.indexOf(self.user._id) === -1)) {
        Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.fileNotEditable'], duration: 5});
        self.options.editSaved = true;
        Application.navigation.goToHome();
      }
      self.presentation = presentation;
      if(!self.presentation.privacy_collaborators) {
        self.presentation.privacy_collaborators = [];
      }
      if(self.presentation.privacy_collaborators.length && !self.user.is_collaborator) {
        self.showCollaborators = true;
      }
      self.communications.saving = false;
      setTimeout(function() {
        self.options.editSaved = true;
      }, 5);
    }).catch(function(err) {
      Application.navigation.goTo('/overview/content');
      Application.messaging.addMessage({type: 'error', text: 'This presentation does not exist.', duration: 5});
    });
  };

  $translate(['edit.general.notification_fieldsMissing',
    'edit.general.notification_titleMissing',
    'edit.general.notification_confirmLeave',
    'modules.notifications.presentation_createdPt1',
    'modules.notifications.presentation_createdPt2',
    'modules.notifications.presentation_savedPt1',
    'modules.notifications.presentation_savedPt2',
    'modules.notifications.presentation_removed',
    'modules.notifications.fileNotEditable']).then(function(translations) {
    self.translations = translations;
  });

  self.initialize();

}]);
